import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import Helmet from 'react-helmet';

import Hero from '../../components/Hero/Hero';

import SeekerPrawn from '../../images/seeker-prawn.jpg';
import Ecosystem from '../../images/ecosytem.jpg';
import device from '../../theme/MediaQueries';
import PostCardItem from '../../components/PostCardItem/PostCardItem';

import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// import birthdayImage from '../../images/birthday-hero.png';
import birthdayImage from '../../images/prawns/hb-fluf.png';

import prawnImage from '../../images/seeker-prawn.jpg';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
// import CardItem from '../../components/CardItem/CardItem';

import ThemeDefault from '../../theme/ThemeDefault';

import CountdownSection from '../../components/CountdownSection/CountdownSection';

import { SiteContext } from '../../components/context/SiteContext';
import Error from '../../components/Error';

import FlufBG from '../../images/fluf-bg.jpg';
import FlufWorld from '../../images/Fluf-World.jpg';
import FlufTeam from '../../images/nfl-team-blur.jpg';
import BlockChainSec from '../../images/blockchainSecurity.jpg';
import { Link } from 'react-router-dom';
import LoaderBlock from '../../components/LoaderBlock/LoaderBlock';
import { Timeline } from 'react-twitter-widgets';

import ReactPlayer from 'react-player';
import moment from 'moment';
import Birthday from '../../components/HappyBirthday/Birthday';

const HomeDiv = styled.div`
	overflow-x: hidden;
`;

const StyledSection = styled.section`
	overflow-x: visible;

	+ section .section-inner {
		padding-top: 0;
	}

	& .intro-card {
		width: 80%;
		margin: 0 auto;

		@media ${device.MXmd} {
			width: 100%;
		}
	}

	& .CardLogoWrap {
		z-index: 3;
		height: 40px;
		width: auto;
		text-align: left;
		margin-bottom: 0.8rem;
	}

	& .CardLogoWrap img {
		width: 100%;
		width: 100%;
		height: 100%;
		text-align: left;
		object-fit: contain;
		object-position: left;
	}

	& .swiper-slide {
		@media ${device.MXmd} {
			padding: 0.8rem !important;
		}
	}

	.rds-slide {
		& a {
			color: ${ThemeDefault.white};
			text-decoration: none;
			text-align: left;
		}
	}
`;

const VideosWrap = styled.div`
	padding: 0;
	overflow: hidden;
	position: relative;
	padding-bottom: 56.25%;

	& .inner {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
		height: 100%;
	}
`;
const TimelineElement = styled.div`
	box-shadow: 2.8px 2.8px 2.2px rgba(0, 0, 0, 0.02),
		6.7px 6.7px 5.3px rgba(0, 0, 0, 0.028),
		12.5px 12.5px 10px rgba(0, 0, 0, 0.035),
		22.3px 22.3px 17.9px rgba(0, 0, 0, 0.042),
		41.8px 41.8px 33.4px rgba(0, 0, 0, 0.05), 100px 100px 80px rgba(0, 0, 0, 0.07);
	border-radius: 2rem;
	overflow: hidden;

	& iframe {
		margin-bottom: -10px !important;
	}
`;

const IntroContent = styled.div`
	& h2 {
		font-size: var(--text-xxl);
		line-height: 1;
	}

	& div {
		font-size: var(--text-m);
	}
`;


const IntroCard = styled(Link)`
	position: relative;
	padding: 0 !important;
	padding-bottom: 56.25% !important;
	overflow: hidden;
	transition: 300ms;
	background-color: ${ThemeDefault.primary};

	&:hover {
		transform: scale(1.05);
	}

	& img {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
	}

	& div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		padding: 1.8rem;
		background-color: var(--primary);
		height: 100%;
		display: flex;
		align-content: center;
		align-items: center;
		justify-content: center;
		font-size: var(--text-l);
		line-height: 1.1;
		background-color: rgba(0, 0, 0, 0.6);
	}
`;
const VideoWrap = styled.div`
	& > div {
		width: 100%;
		position: absolute;
		height: 100% !important;

		& iframe {
			height: 100%;
			width: 100%;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
	}

	& video {
		object-fit: cover !important;
	}
`;
export default function Home() {
	const {
		postsData,
		countDownData,
		postsPending,
		collectionsData,
		countdownPending,
		errors,
		tagData,
	} = useContext(SiteContext);

	// const [amasData, setAmasData] = useState({})
	const [podcastsData, setPodcastsData] = useState({});
	const [newsData, setNewsData] = useState({});
	const [newsletterData, setNewsletterData] = useState({});
	const [commData, setcommData] = useState({});

	const [isBirthday, setIsBirthday] = useState(false);

	useEffect(() => {
		let abortController = new AbortController();

		const amaID =
			tagData && tagData.length > 0
				? tagData.filter((tag) => tag.slug === 'ama').reduce((arr) => arr)
				: null;
		const podcastID =
			tagData && tagData.length > 0
				? tagData.filter((tag) => tag.slug === 'podcast').reduce((arr) => arr)
				: null;
		const newsletterID =
			tagData && tagData.length > 0
				? tagData.filter((tag) => tag.slug === 'newsletter').reduce((arr) => arr)
				: null;
		const communityID =
			tagData && tagData.length > 0
				? tagData.filter((tag) => tag.slug === 'community').reduce((arr) => arr)
				: null;

		// const amas = (postsData && postsData.length > 0 && amaID) ? postsData.filter(collection => collection.tags.includes(parseInt(amaID.id))) : null
		const podcasts =
			postsData && postsData.length > 0 && podcastID
				? postsData.filter(
						(collection) =>
							collection.tags.includes(parseInt(podcastID.id)) ||
							collection.tags.includes(parseInt(amaID.id)),
				  )
				: null;
		const community =
			postsData && postsData.length > 0 && communityID
				? postsData.filter((collection) =>
						collection.tags.includes(parseInt(communityID.id)),
				  )
				: null;

		const newsletter =
			postsData && postsData.length > 0 && newsletterID
				? postsData.filter((collection) =>
						collection.tags.includes(parseInt(newsletterID.id)),
				  )
				: null;

		// setAmasData( () => {
		//     return amas
		//   }
		// )
		setPodcastsData(() => {
			// return (podcasts && podcasts.length > 0) ? podcasts.filter(collection => !amas.includes(collection)) : null
			return podcasts;
		});
		
		setNewsletterData(() => {
			return newsletter
		});

		setcommData(() => {
			return community && community.length > 0
				? community.filter((collection) => !podcasts.includes(collection))
				: null;
		});

		setNewsData(() => {
			return postsData && postsData.length > 0 && communityID && podcastID
				? postsData.filter(
						(collection) =>
							!podcasts.includes(collection) && !community.includes(collection) && !newsletter.includes(collection)
				  )
				: null;
		});



		return () => abortController.abort();
	}, [postsData, tagData, collectionsData]);
	

	useEffect(() => {
		const birthday = moment('2022-08-08');
		const isbday = birthday.isSame(new Date(), "day");
		setIsBirthday(isbday)
	}, [])

	return (
		<HomeDiv className="page-wrap Home">
			<Helmet>
				<meta charSet="utf-8" />
				<title>The Prawns | The Futureverse Guide</title>
				<link rel="canonical" href="https://theprawns.xyz/" />

				<meta
					property="og:title"
					content="The Prawns Guide to Fluf World & The Futureverse"
				/>
				<meta property="og:url" content="https://theprawns.xyz/" />
				<meta
					property="og:description"
					content="The Prawns are a community project & the single point of information from all corners of The Futureverse Ecosystem"
				/>
				<meta property="og:image" content={SeekerPrawn} />
				<meta property="og:type" content="website" />

				<meta property="twitter:url" content="https://theprawns.xyz/" />
				<meta
					property="twitter:title"
					content="The Prawns Guide to Fluf World & The Futureverse"
				/>
				<meta
					property="twitter:description"
					content="The Prawns are a community project & the single point of information from all corners of The Futureverse Ecosystem"
				/>
				<meta property="twitter:image" content={SeekerPrawn} />
			</Helmet>

			{
				isBirthday ? 
					<StyledSection className="page-width" style={{ paddingTop: "clamp(3.2rem, calc(3vw + 3.6rem), 8rem)", paddingBottom: "0" }}>
						<div className="section-inner" style={{ paddingTop: 0 }}>
							<Birthday flufImage={birthdayImage} />
						</div>
					</StyledSection>
				:	
					<Hero
						isHome="true"
						pretitle="The Prawns Guide to Fluf World & The Futureverse"
						title="Welcome To The Prawn Hub"
						heroText="The Prawns are a community-driven project and central point of information from all corners of Fluf World & The Futureverse Ecosystem."
						heroImage={isBirthday ? birthdayImage : prawnImage}
					/>
			}

			<StyledSection className="page-width" style={{ marginTop: '4.4rem' }}>
				<div className="section-inner">
					<IntroContent className="grid--1 gap--l" style={{ fontSize: '2.4rem' }}>
						Join us down the literal rabbit hole and discover what the Fluf is going
						on. With numerous integrated, PFP and metaverse-ready projects, The
						Futureverse is not just another NFT project. It’s a game, a brand, a world
						in itself, but most of all, Fluf brings together a community of creative
						and diverse individuals who are eager to grow and co-create.
					</IntroContent>
				</div>
			</StyledSection>

			{errors && errors.length > 0 && <Error errors={errors} />}

			{countDownData && countDownData.length > 0 ? (
				<CountdownSection isHome={true} countdownData={countDownData} />
			) : (
				countdownPending && (
					<StyledSection className="page-width">
						<LoaderBlock
							title="Loading Key Countdowns"
							wrapperClasses="section-inner"
							titleClasses="title-loading loading center"
							type="countdowns"
							textAlign="center"
							showTitle={true}
						/>
					</StyledSection>
				)
			)}

			<StyledSection className="page-width" style={{marginTop: 0, paddingTop: 0}}>
				<div className="section-inner" style={{marginTop: 0, paddingTop: 0}}>
					<h2>Futureverse Trailer</h2>
					<VideosWrap className="0card">
						<div className="inner">
							<div className="videoOuter">
								<VideoWrap className="inner">
									<ReactPlayer
										controls={true}
										playsinline={true}
										width="100%"
										url="https://player.vimeo.com/video/781543095?h=4d7379cbae"
										config={{file:{attributes:{poster: 'https://i.vimeocdn.com/video/1568811342-ea157702c5e039a3d56a245263341ad619f6a02cc970dbba52e06c229a5030aa-d?mw=3900&mh=2194&q=70'}}}} poster={'https://i.vimeocdn.com/video/1568811342-ea157702c5e039a3d56a245263341ad619f6a02cc970dbba52e06c229a5030aa-d?mw=3900&mh=2194&q=70'}
									/>
								</VideoWrap>
							</div>
						</div>
					</VideosWrap>
				</div>
			</StyledSection>

			<StyledSection className="page-width" style={{ marginTop: '4.4rem' }}>
				<div className="section-inner">
					<IntroContent className="grid--2-3 grid--l-1 gap--l">
						<div className="text--left">
							<h2>New to Fluf World & The Futureverse?</h2>
							<div className="owl--s">
								<p>
									{' '}
									The Futureverse is a vast metaverse ecosystem of NFT collectables, all
									interconnected with a wide range of utility.{' '}
								</p>
								<p>
									{' '}
									If you are completely new to crypto, we recommend heading to the{' '}
									<Link
										to="/getting-started"
										style={{ fontWeight: '700', textDecoration: 'underline' }}
									>
										Getting Started
									</Link>{' '}
									page to learn about how to get set up before making your first NFT
									investment.{' '}
								</p>
							</div>
						</div>
						<div className="grid--2 grid--s-1 grid--m-2  gap--s">
							<IntroCard to="/futureverse-guide" className="card ">
								<img src={FlufBG} alt="The Futureverse" />
								<div>Learn About the Ecosystem</div>
							</IntroCard>
							<IntroCard to="/futureverse/timeline" className="card ">
								<img src={Ecosystem} alt="The Futureverse Timeline" />
								<div>See The Futureverse Timeline</div>
							</IntroCard>
							<IntroCard to="/the-team-behind-futureverse" className="card ">
								<img src={FlufTeam} alt="The Futureverse" />
								<div>Who's Behind The Futureverse</div>
							</IntroCard>
							<IntroCard to="/futureverse" className="card ">
								<img src={FlufWorld} alt="The Futureverse" />
								<div>See The Futureverse Projects</div>
							</IntroCard>
							<IntroCard to="/getting-started" className="card ">
								<img src={BlockChainSec} alt="The Futureverse" />
								<div>New to Crypto? Learn More</div>
							</IntroCard>
							<IntroCard
								to="/getting-started/mental-health-awareness"
								className="card "
							>
								<img src={FlufBG} alt="Mental Health Awareness" />
								<div>Mental Health Awareness</div>
							</IntroCard>
						</div>
					</IntroContent>
				</div>
			</StyledSection>

			<StyledSection className="page-width" style={{marginTop: 0, paddingTop: 0}}>
				<div className="section-inner" style={{marginTop: 0, paddingTop: 0}}>
					<h2>Buzzie's Trailer</h2>
					<VideosWrap className="0card">
						<div className="inner">
							<div className="videoOuter">
								<VideoWrap className="inner">
									<ReactPlayer
										controls={true}
										playsinline={true}
										width="100%"
										url="https://media.graphassets.com/fuKmJv0vS56fo30cbk5T"
										config={{file:{attributes:{poster: 'https://media.graphassets.com/1qXMigywQdC7Bb4144Eg'}}}} poster={'https://media.graphassets.com/1qXMigywQdC7Bb4144Eg'}
									/>
								</VideoWrap>
							</div>
						</div>
					</VideosWrap>
				</div>
			</StyledSection>

			<StyledSection className="page-width">
				<div className="section-inner">
					<IntroContent className="grid--2-3 grid--l-1 gap--l">
						<div className="text--left">
							<h2>Current Investor in The Futureverse?</h2>
							<div className="owl--l">
								Use these quick links to get the information you need, fast!
							</div>
						</div>
						<div className="grid--2 grid--s-1 grid--m-2  gap--s">
							<IntroCard to="/news" className="card no-image">
								<div>Latest News</div>
							</IntroCard>
							<IntroCard to="/stats" className="card no-image">
								<div>Latest Stats</div>
							</IntroCard>
							<IntroCard to="/asset" className="card no-image">
								<div>Download your Fluf Assets & Check Reveal Status</div>
							</IntroCard>
							<IntroCard to="/resources" className="card no-image">
								<div>Other Essential Resources</div>
							</IntroCard>
						</div>
					</IntroContent>
				</div>
			</StyledSection>

			<StyledSection className="page-width">
				<div className="section-inner">
					<VideosWrap>
						<div className="inner">
							<div className="videoOuter">
								<VideoWrap className="inner">
									<ReactPlayer
										controls={true}
										playsinline={true}
										width="100%"
										url="https://www.youtube.com/watch?v=lZX54XJr4uU&t"
									/>
								</VideoWrap>
							</div>
						</div>
					</VideosWrap>
				</div>
			</StyledSection>

			<StyledSection className="page-width">
				<div className="section-inner">
					<div className="owl--xxl">
						{commData && commData.length > 0 ? (
							<div className="" id="posts">
								<h2 className="text--left">Community Newsletters</h2>
								<Swiper
									// install Swiper modules
									modules={[Navigation, Pagination, Scrollbar, A11y]}
									breakpoints={{
										480: {
											slidesPerView: 1,
											spaceBetween: 16,
										},
										768: {
											slidesPerView: 2,
											spaceBetween: 24,
										},
										992: {
											slidesPerView: 3,
											spaceBetween: 32,
										},
									}}
									navigation
									scrollbar={{ draggable: false }}
									// onSwiper={(swiper) => }
									// onSlideChange={() => }
								>
									{newsletterData.map((post) => (
										<SwiperSlide key={post.id}>
											<PostCardItem
												key={`newsletter-${post.id}`}
												className="Post"
												showTag={true}
												showLogo={true}
												post={post}
											/>
										</SwiperSlide>
									))}
								</Swiper>
							</div>
						) : (
							postsPending && (
								<LoaderBlock
									title="Loading Community Newsletters"
									titleClasses="title-loading loading left"
									type="3-col"
									textAlign="left"
									showTitle={true}
								/>
							)
						)}
					</div>
				</div>
			</StyledSection>

			<StyledSection className="page-width">
				<div className="section-inner">
					<div className="owl--xxl">
						{commData && commData.length > 0 ? (
							<div className="" id="posts">
								<h2 className="text--left">Community Events & Podcasts</h2>
								<Swiper
									// install Swiper modules
									modules={[Navigation, Pagination, Scrollbar, A11y]}
									breakpoints={{
										480: {
											slidesPerView: 1,
											spaceBetween: 16,
										},
										768: {
											slidesPerView: 2,
											spaceBetween: 24,
										},
										992: {
											slidesPerView: 3,
											spaceBetween: 32,
										},
									}}
									navigation
									scrollbar={{ draggable: false }}
									// onSwiper={(swiper) => }
									// onSlideChange={() => }
								>
									{commData.map((post) => (
										<SwiperSlide key={post.id}>
											<PostCardItem
												key={`news-${post.id}`}
												className="Post"
												showTag={true}
												showLogo={true}
												post={post}
											/>
										</SwiperSlide>
									))}
								</Swiper>
							</div>
						) : (
							postsPending && (
								<LoaderBlock
									title="Loading Community Events & Podcasts"
									titleClasses="title-loading loading left"
									type="3-col"
									textAlign="left"
									showTitle={true}
								/>
							)
						)}
					</div>
				</div>
			</StyledSection>

			<StyledSection className="page-width">
				<div className="section-inner">
					<div className="owl--xxl">
						{newsData && newsData.length > 0 ? (
							<div className="" id="posts">
								<h2 className="text--left">Recent News & Events</h2>
								<Swiper
									// install Swiper modules
									modules={[Navigation, Pagination, Scrollbar, A11y]}
									breakpoints={{
										480: {
											slidesPerView: 1,
											spaceBetween: 16,
										},
										768: {
											slidesPerView: 2,
											spaceBetween: 24,
										},
										992: {
											slidesPerView: 3,
											spaceBetween: 32,
										},
									}}
									navigation
									scrollbar={{ draggable: false }}
									// onSwiper={(swiper) => }
									// onSlideChange={() => }
								>
									{newsData.map((post) => (
										<SwiperSlide key={post.id}>
											<PostCardItem
												key={`news-${post.id}`}
												className="Post"
												showTag={true}
												showLogo={true}
												post={post}
											/>
										</SwiperSlide>
									))}
								</Swiper>
							</div>
						) : (
							postsPending && (
								<LoaderBlock
									title="Loading News & Events"
									titleClasses="title-loading loading left"
									type="3-col"
									textAlign="left"
									showTitle={true}
								/>
							)
						)}
					</div>
				</div>
			</StyledSection>

			<StyledSection className="page-width">
				<div className="section-inner">
					<div className="owl--xxl">
						{podcastsData && podcastsData.length > 0 ? (
							<div className="" id="posts">
								<h2 className="text--left">Podcasts & AMAs</h2>
								<Swiper
									// install Swiper modules
									modules={[Navigation, Pagination, Scrollbar, A11y]}
									breakpoints={{
										480: {
											slidesPerView: 1,
											spaceBetween: 16,
										},
										768: {
											slidesPerView: 2,
											spaceBetween: 24,
										},
										992: {
											slidesPerView: 3,
											spaceBetween: 32,
										},
									}}
									navigation
									scrollbar={{ draggable: false }}
									// onSwiper={(swiper) => }
									// onSlideChange={() => }
								>
									{podcastsData.map((post) => (
										<SwiperSlide key={post.id}>
											<PostCardItem
												key={`podcasts-${post.id}`}
												className="Post"
												showTag={false}
												showLogo={true}
												post={post}
											/>
										</SwiperSlide>
									))}
								</Swiper>
							</div>
						) : (
							postsPending && (
								<LoaderBlock
									title="Loading Podcasts"
									titleClasses="title-loading loading left"
									type="3-col"
									textAlign="left"
									showTitle={true}
								/>
							)
						)}
					</div>
				</div>
			</StyledSection>

			<StyledSection className="page-width">
				<div className="section-inner">
					<div className="owl--xxl">
						<div className="grid--2 gap--xl grid--m-1">
							<div className="wrapper">
								<div className="titleWrap">
									<h2 style={{ color: ThemeDefault.white }}>Ecosystem Tweets</h2>
								</div>
								<TimelineElement>
									<Timeline
										dataSource={{
											sourceType: 'list',
											ownerScreenName: 'twitter',
											id: '1519965459465924613',
										}}
										options={{ theme: 'dark', width: '100%', height: '600' }}
									/>
								</TimelineElement>
							</div>

							<div className="wrapper">
								<div className="titleWrap">
									<h2 style={{ color: ThemeDefault.white }}>Ecosystem Sales</h2>
								</div>
								<TimelineElement>
									<Timeline
										dataSource={{
											sourceType: 'profile',
											screenName: 'flufworldbot',
										}}
										options={{ theme: 'dark', width: '100%', height: '600' }}
									/>
								</TimelineElement>
							</div>
						</div>
					</div>
				</div>
			</StyledSection>
		</HomeDiv>
	);
}